import { useNavigate } from "react-router-dom";
import { ReportMetadataItem } from "../../../../models/pageModels/ReportLibrary";
import { useRefreshLock } from "../../../../hooks/reports/useRefreshLock";
import { useModalStore } from "../../../../store/report/modalStore";
import { useReportViewStore } from "../../../../store/report/useReportViewStore";
import DropDownWithPortal from "../../../UI/DropDownWithPortal";
import SidePanelItem from "./SidePanelItem";
import { reportsDashboardEnabled } from "../../../../utils/features";

interface SidePanelGroupProps {
  id: string;
  groupName: string;
  reports: ReportMetadataItem[];
}

const SidePanelGroup = ({ id, groupName, reports }: SidePanelGroupProps) => {
  const isExpanded = useReportViewStore((s) => s.expandedGroups[id] ?? false);
  const toggleGroupExpanded = useReportViewStore((s) => s.toggleGroupExpanded);
  const navigate = useNavigate();
  const openModal = useModalStore((s) => s.openModal);
  const { isLocked } = useRefreshLock({ groupId: id });

  const handleGroupHeaderClick = () => {
    if (reportsDashboardEnabled) {
      navigate(`/reports/groups/${id}`);
      return;
    }

    toggleGroupExpanded(id);
  };

  const executeAction = (fn: () => void) => { 
    fn(); 
    document.dispatchEvent(new CustomEvent("closeOtherDropdowns", { detail: { dropdownId: "close-all" } })); 
  };

  const menuOptions = [
    { label: "Rename Group", onClick: () => executeAction(() => openModal("renameGroup", { id, name: groupName })) },
    { label: "Delete Group", onClick: () => executeAction(() => openModal("deleteGroup", { id })) },
  ];

  return (
    <div className="side-panel-group">
      <div className={`group-header ${isExpanded ? "expanded" : ""}`} onClick={handleGroupHeaderClick}>
        <div className="group-info">
          <i className={isExpanded ? "ri-arrow-down-s-line" : "ri-arrow-right-s-line"} onClick={(e) => { e.stopPropagation(); toggleGroupExpanded(id); }} />
          <i className="ri-folder-fill group-folder-icon" />
          <span className="group-name" title={groupName}>{groupName}</span>
          <span className="group-count margin-left-1">({reports.length})</span>
          {isLocked && <i className="ri-loader-4-line spin text-muted margin-left-2" title="Dashboard refreshing..." />}
        </div>
        <div className="group-actions" onClick={(e) => e.stopPropagation()}>
          <DropDownWithPortal id={`group-menu-${id}`} options={menuOptions} disabled={isLocked} />
        </div>
      </div>

      {isExpanded && (
        <ul className="group-items">
          {reports.map((report) => (
            <SidePanelItem key={report.id} report={report} isSelectable={true} />
          ))}
        </ul>
      )}
    </div>
  );
};

export default SidePanelGroup;
